import CouponComponent from "../../components/admin/coupons/CouponComponent";
import CouponListComponent from "../../components/admin/coupons/CouponListComponent";
import CouponShowComponent from "../../components/admin/coupons/CouponShowComponent";

export default [
    {
        path: "/admin/cupones",
        component: CouponComponent,
        name: "admin.coupons",
        redirect: { name: "admin.coupons.list" },
        meta: {
            isFrontend: false,
            auth: true,
            permissionUrl: "coupons",
            breadcrumb: "coupons",
        },
        children: [
            {
                path: "",
                component: CouponListComponent,
                name: "admin.coupons.list",
                meta: {
                    isFrontend: false,
                    auth: true,
                    permissionUrl: "coupons",
                    breadcrumb: "",
                },
            },
            {
                path: "ver/:id",
                component: CouponShowComponent,
                name: "admin.coupon.show",
                meta: {
                    isFrontend: false,
                    auth: true,
                    permissionUrl: "coupons",
                    breadcrumb: "view",
                },
            },
        ],
    },
];
